import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import {
  CreateSmartSmsNumberClassCommand,
  Item,
  UpdateSmartSmsNumberClassCommand,
} from 'src/app/core/api/models';
import { SmartSmsNumberClassesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { SmartSmsNumberClassesFieldsFieldsComponent } from './smart-sms-number-classes-fields/smart-sms-number-classes-fields.component';

@Component({
  selector: 'app-smart-sms-number-classes-form',
  templateUrl: './smart-sms-number-classes-form.component.html',
  imports: [BaseFormModule, SmartSmsNumberClassesFieldsFieldsComponent],
})

export class SmartSmsNumberClassesFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  @Input() classesModel: any;
  @Input('isEdit') isEdit;

  model: CreateSmartSmsNumberClassCommand = {};
  newClassModel: Item[] = [];
  createClassesForms: FormGroup[] = [];

  @Output('closePage') output_closPage = new EventEmitter<boolean>();

  //#endregion

  constructor(protected currentService: SmartSmsNumberClassesService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.fields = 'pages.smartSmsNumberClasses.form.fields.';
      this.pageVocabs = 'pages.smartSmsNumberClasses.form.';
      this.title = 'pages.smartSmsNumberClasses.title';
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  //#region init methods

  initModel(): void {
    try {
      if (this.classesModel && this.isEdit) {
        this.newClassModel = Object.assign(
          [],
          this.classesModel.apiIpRules[0].rules
        );
      } else {
        this.newClassModel = [];
        this.onAddClass();
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  initForm(): void {
    this.form = new FormGroup({
      province: new FormControl(''),
      city: new FormControl(''),
      class: new FormControl(''),
    });
  }

  isValidCreateRulesForms(): boolean {
    try {
      let result: boolean = true;

      this.createClassesForms.forEach((form) => {
        if (form.invalid) {
          result = false;
          form.markAllAsTouched();
        }
      });

      return result;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  //#endregion

  //#region api

  //Create
  baseCreateApi(model: CreateSmartSmsNumberClassCommand): void {
    this.unSubs();

    this.loading = true;
    model.items = this.newClassModel;
    this.currentService
      .smartSmsNumberClassesCreate({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateSmartSmsNumberClassCommand): void {
    this.unSubs();
    //todo
    this.loading = true;
    // model.ipRules = this.newRulesModel;
    this.currentService
      .smartSmsNumberClassesUpdate({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    try {
      if (this.loading) return;

      if (!this.isValidForm(this.form, this.tagName)) return;

      if (!this.isValidCreateRulesForms()) return;

      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  checkCreateOrUpdate() {
    if (this.loading || !this.form.valid) return;
    //todo
    if (this.isEdit) this.baseUpdateApi({ class: 0, id: 0 });
    else this.baseCreateApi(this.model);
  }

  onClose() {
    this.output_closPage.emit(true);
  }

  //#region ipRules

  onAddClass() {
    try {
      this.newClassModel.push({
        city: '',
        cityId: 0,
        class: 0,
        province: '',
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  onRemoveClass(index: number) {
    try {
      if (this.newClassModel.length > 1 || this.isEdit)
        this.newClassModel.splice(index, 1);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  //#endregion
}
